module.exports = require("@swa-ui/itinerary/src/ConfirmationNumber/ConfirmationNumber.module.scss");